import { render } from "./adminPanel.vue?vue&type=template&id=01da2875&scoped=true"
import script from "./adminPanel.vue?vue&type=script&lang=js"
export * from "./adminPanel.vue?vue&type=script&lang=js"

import "./adminPanel.vue?vue&type=style&index=0&id=01da2875&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01da2875"]])

export default __exports__